import { CategoryType } from 'owa-categories';

export default function isCategoryNameValid(name: string, categoryList: CategoryType[]): boolean {
    // Valid category name means the name string is not white space, or null, or empty
    // and it is not duplicated with existing categories
    return !(isCategoryNameEmptyOrWhitespace(name) || isCategoryNameDuplicate(name, categoryList));
}

export function isCategoryNameEmptyOrWhitespace(name: string): boolean {
    return !name || !name.trim();
}

/**
 * Determines whether a category has duplicate name with existing categories
 * @param name of the category to be checked
 * @param categoryList the list of categories
 * @returns true if a category does not have duplicate name with existing categories, false otherwise
 */
export function isCategoryNameDuplicate(name: string, categoryList: CategoryType[]): boolean {
    const trimmedName = name.trim();
    let categoriesWithDuplicateName = categoryList.filter(
        categoryRow => categoryRow.Name.toLocaleLowerCase() === trimmedName.toLocaleLowerCase()
    );

    // Not a valid name if it is duplicate with other existing categories
    return categoriesWithDuplicateName.length > 0;
}
